import React from "react";
import "./ComingSoon.css";
const CommingSoon = ({ location }) => {
  return (
    <div className={`container-fluid  parentDiv`}>
      <div className={`text-center divCenter`}>
        <h1 className={`display-4`}>{`${location} Page Coming Soon....`}</h1>
      </div>
    </div>
  );
};

export default CommingSoon;
